export default (colorString) => {
    let borderColors = String(colorString).match(/rgb(a)*\(\d{1,3}\s*\,\s*\d{1,3}\s*\,\s*\d{1,3}(\,\s*\d(\.\d)*)*\)/g)
    if (borderColors) {
        if (borderColors.length == 1) {
            return {
                top: borderColors[0],
                bottom: borderColors[0],
                right: borderColors[0],
                left: borderColors[0]
            }
        } else if (borderColors.length == 2) {
            return {
                top: borderColors[0],
                bottom: borderColors[0],
                right: borderColors[1],
                left: borderColors[1]
            }
        } else if (borderColors.length == 3) {
            return {
                top: borderColors[0],
                right: borderColors[1],
                left: borderColors[1],
                bottom: borderColors[2]
            }
        } else if (borderColors.length == 4) {
            return {
                top: borderColors[0],
                right: borderColors[1],
                bottom: borderColors[2],
                left: borderColors[3]
            }
        }
    }
    return null
}